// extracted by mini-css-extract-plugin
module.exports = {"article__container":"style_article__container__fGZM1","quote__inner":"style_quote__inner__T_7kX"};